import { useGetRegionPageAvailableBanners } from 'api/regions/hooks';
import { useFetchLocationAvailableBanners } from 'api/locations/hooks';
import { useFetchRetailerPageAvailableBanners, useFetchStore } from 'api/store/hooks';
import { useParams } from 'react-router-dom';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

export const useLocationBannerAvailableItems = () => {
  const { locationUid } = useParams();
  const { data, isLoading } = useFetchLocationAvailableBanners(locationUid);

  return { items: data || [], isLoading };
};

export const useStoreBannerAvailableItems = () => {
  const { data: store } = useFetchStore();
  const { data, isLoading } = useFetchRetailerPageAvailableBanners(store?.uid, {
    enabled: !!store?.uid,
  });

  return { items: data || [], isLoading };
};

export const useRegionBannerAvailableItems = () => {
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);
  const { data, isLoading } = useGetRegionPageAvailableBanners(selectedRegion);

  return { items: data || [], isLoading };
};
